import WeatherDataService from "../../services/weather_data/service";
import { onConfig } from "@/config";

let weatherDataService = null;

onConfig((config) => {
  weatherDataService = new WeatherDataService(config.VUE_APP_BASIC_URL);
});

const getDefaultState = () => {
  return {
    weatherData: [],
    fetchLoading: true,
    fetchError: null,
  };
};

const state = getDefaultState();

const getters = {
  fetchRequestFailed: (state) => (state.fetchError !== null),
  emptyWeatherData: (state) => (state.weatherData.length === 0 && !state.fetchError && !state.fetchLoading),
  chartOptions: (state) => {
    return {
      chart: {
        polar: true,
        type: "column",
        title: {
          text: "",
        },
      },
      title: {
        text: null,
      },
      tooltip: {
        distance: 5,
        valueSuffix: " %",
        valueDecimals: 1,
      },
      legend: {
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal",
        width: "100%",
        itemStyle: {
          fontSize: "10px"
        },
        labelFormatter: function () {
          const total = this.yData.reduce(
            (accumulator, currentValue) => accumulator + currentValue
          );
          return this.name + " (" + total.toFixed(1) + " % )";
        },
      },
      xAxis: {
        categories: [
          "0.0",
          "22.5",
          "45.0",
          "67.5",
          "90.0",
          "112.5",
          "135.0",
          "157.5",
          "180.0",
          "202.5",
          "225.0",
          "247.5",
          "270.0",
          "292.5",
          "315.0",
          "337.5",
        ],
        tickmarkPlacement: "on",
      },
      yAxis: {
        min: 0,
        endOnTick: false,
        showLastLabel: true,
        labels: {
          formatter: function () {
            return this.value;
          },
        },
        reversedStacks: false,
      },
      plotOptions: {
        series: {
          stacking: "normal",
          shadow: false,
          groupPadding: 0,
          pointPlacement: "on",
        },
      },
      credits: {
        enabled: false,
      },
      series: state.weatherData,
    };
  }
};

const actions = {
  async fetchWeatherData({ commit }, payload) {
    commit("SET_FETCH_LOADING_STATE");
    try {
      const weatherData = await weatherDataService.getWindData(
        localStorage.getItem("quad_token"),
        payload.name,
        payload.startDate,
        payload.stopDate
      );
      commit("SET_FETCH_SUCCESS_STATE", weatherData);
    } catch (error) {
      commit("SET_FETCH_ERROR_STATE", error);
    }
  }
};

const mutations = {
  SET_FETCH_LOADING_STATE(state) {
    state.fetchLoading = true;
  },
  SET_FETCH_SUCCESS_STATE(state, weatherData) {
    state.weatherData = weatherData;
    state.fetchLoading = false;
  },
  SET_FETCH_ERROR_STATE(state, error) {
    state.fetchError = error;
    state.weatherData = [];
    state.fetchLoading = false;
  }
};

export const weatherDataModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
